import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Table, TableColumnsType, Tooltip } from 'antd'
import dayjs from 'dayjs'

import { ONLY_DATE_FORMAT } from '../../../../constants/global'
import { numberFormat } from '../../../../utils'
import { IStockReportDailyRow } from './types'

interface Props {
  data: IStockReportDailyRow[]
  isLoading?: boolean
  onSelectDate: (date: string) => void
}

const signStyle = (value: number) =>
  value > 0
    ? { color: '#389e0d' }
    : value < 0
      ? { color: '#cf1322' }
      : undefined

const StockDeductionDailyTable = ({
  data,
  isLoading,
  onSelectDate,
}: Props) => {
  const columns: TableColumnsType<IStockReportDailyRow> = [
    {
      title: 'วันที่',
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => (
        <Tooltip title="ดูรายละเอียดของวันนี้">
          <span
            role="button"
            onClick={() => onSelectDate(date)}
            style={{
              color: '#1677ff',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            {dayjs(date).format(ONLY_DATE_FORMAT)}
            <OpenInNewIcon sx={{ fontSize: 14 }} />
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'ตัด (ชิ้น)',
      dataIndex: 'reduceQuantity',
      key: 'reduceQuantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'คืน (ชิ้น)',
      dataIndex: 'addQuantity',
      key: 'addQuantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'สุทธิ (ชิ้น)',
      dataIndex: 'netQuantity',
      key: 'netQuantity',
      align: 'right',
      render: (value: number) => (
        <span style={signStyle(value)}>{numberFormat(value, 0)}</span>
      ),
    },
    {
      title: 'มูลค่าต้นทุน (฿)',
      dataIndex: 'netCost',
      key: 'netCost',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'รายการ',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'ออเดอร์',
      dataIndex: 'orderCount',
      key: 'orderCount',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'ตัดไม่ได้ (ชิ้น)',
      dataIndex: 'failureQuantity',
      key: 'failureQuantity',
      align: 'right',
      // 0 = ไม่มีปัญหา จึงไม่ย้อมสี ย้อมเฉพาะตอนมีของตกหล่นจริง
      render: (value: number) => (
        <span style={value > 0 ? { color: '#fa8c16' } : undefined}>
          {numberFormat(value, 0)}
        </span>
      ),
    },
  ]

  return (
    <Table<IStockReportDailyRow>
      rowKey="date"
      columns={columns}
      dataSource={data}
      loading={isLoading}
      size="small"
      pagination={{ pageSize: 31, showSizeChanger: false }}
      locale={{ emptyText: 'ไม่มีการตัดสต๊อกในช่วงที่เลือก' }}
    />
  )
}

export default StockDeductionDailyTable
